import {
  GetComisionMembresiaPlantilla,
  PostComisionMembresiaPlantilla,
  PostComisionMembresiaPlantillaConfirmar,
  DeleteComisionMembresiaPlantilla,
  PutRegionMetas,
  PutClubMetas,
  PutAsesoresMetas
} from "../../../reducers/comisionMembresia";

export interface ConfiguracionPlantillaStore
  extends GetComisionMembresiaPlantilla,
    PostComisionMembresiaPlantilla,
    PostComisionMembresiaPlantillaConfirmar,
    DeleteComisionMembresiaPlantilla,
    PutRegionMetas,
    PutClubMetas,
    PutAsesoresMetas {}

export const configuracionPlantillaStore: (
  state
) => ConfiguracionPlantillaStore = state => {
  const comisionMembresia = state.comisionMembresia;

  return {
    comisionMembresiaPlantilla: comisionMembresia.comisionMembresiaPlantilla,
    gettingComisionMembresiaPlantilla:
      comisionMembresia.gettingComisionMembresiaPlantilla,
    gettingComisionMembresiaPlantillaError:
      comisionMembresia.gettingComisionMembresiaPlantillaError,

    plantillaGuardada: comisionMembresia.plantillaGuardada,
    postingComisionMembresiaPlantilla:
      comisionMembresia.postingComisionMembresiaPlantilla,
    postingComisionMembresiaPlantillaError:
      comisionMembresia.postingComisionMembresiaPlantillaError,

    plantillaConfirmada: comisionMembresia.plantillaConfirmada,
    postingComisionMembresiaPlantillaConfirmar:
      comisionMembresia.postingComisionMembresiaPlantillaConfirmar,
    postingComisionMembresiaPlantillaConfirmarError:
      comisionMembresia.postingComisionMembresiaPlantillaConfirmarError,

    plantillaEliminada: comisionMembresia.plantillaEliminada,
    deletingComisionMembresiaPlantilla:
      comisionMembresia.deletingComisionMembresiaPlantilla,
    deletingComisionMembresiaPlantillaError:
      comisionMembresia.deletingComisionMembresiaPlantillaError,

    metasRegionActualizadas: comisionMembresia.metasRegionActualizadas,
    puttingRegionMetas: comisionMembresia.puttingRegionMetas,
    puttingRegionMetasError: comisionMembresia.puttingRegionMetasError,

    metasClubActualizadas: comisionMembresia.metasClubActualizadas,
    puttingClubMetas: comisionMembresia.puttingClubMetas,
    puttingClubMetasError: comisionMembresia.puttingClubMetasError,

    metasAsesoresActualizadas: comisionMembresia.metasAsesoresActualizadas,
    puttingAsesoresMetas: comisionMembresia.puttingAsesoresMetas,
    puttingAsesoresMetasError: comisionMembresia.puttingAsesoresMetasError
  };
};
